import { MenuComponent } from "./menu/menu.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { IonicModule } from "@ionic/angular";
import { RouterModule } from "@angular/router";
import { TranslateModule } from "@ngx-translate/core";
import { SharedDirectivesModule } from "../directives/shared-directives.module";
import { RelayComponent } from "./relay/relay.component";
import { AvatarComponent } from "./avatar/avatar.component";
import { ExpandableComponent } from "./expandable/expandable.component";
import { DetailViewComponent } from "./detail-view/detail-view.component";
import { DetailViewItemComponent } from "./detail-view-item/detail-view-item.component";
import {
  CalendarDatePipe,
  CalendarHeaderComponent,
} from "./calendar-header/calendar-header.component";
import { ImageUploadComponent } from "./image-upload/image-upload.component";
import { PopoverComponent } from "./popover/popover/popover.component";
import { ColorPickerComponent } from "./color-picker/color-picker.component";
import { CountdownTimerComponent } from "./countdown-timer/countdown-timer.component";
import { FilterSelectableComponent } from "./filter-selectable/filter-selectable.component";
import { IonicSelectableModule } from "ionic-selectable";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { SaveDeleteButtonsComponent } from "./save-delete-buttons/save-delete-buttons.component";
import { CurrencyInputComponent } from "./currency-input/currency-input.component";
import { SiselseListPersonsComponent } from "./siselse/persons-list/person-list.component";
import { SiselsePersonComponent } from "./siselse/persons-list/persons.component";
import { SiselseCardComponent } from "./siselse/card/card.component";
import { SiselseCardRequestComponent } from "./siselse/card-request/card-request.component";
import { TransactionPrintComponent } from "./transaction-print/transaction-print.component";
import { CurrencyInputBasicComponent } from "./currency-input-basic/currency-input-basic.component";
import { SelectableItemTemplateComponent } from "./selectable-item/selectable-item-templace/selectable-item-template.component";
import { selectableInstallationComponent } from "./selectable-installation/selectable-installation.component";
import { SiselseInterphoneComponent } from "./siselse/interphones-list/interphone.component";
import { SiselseListInterphonesComponent } from "./siselse/interphones-list/interphones-list.component";

@NgModule({
  declarations: [
    AvatarComponent,
    MenuComponent,
    ExpandableComponent,
    RelayComponent,
    DetailViewComponent,
    DetailViewItemComponent,
    CalendarHeaderComponent,
    CalendarDatePipe,
    ImageUploadComponent,
    PopoverComponent,
    ColorPickerComponent,
    CountdownTimerComponent,
    FilterSelectableComponent,
    SaveDeleteButtonsComponent,
    CurrencyInputComponent,
    CurrencyInputBasicComponent,
    SiselseListPersonsComponent,
    SiselsePersonComponent,
    SiselseCardComponent,
    SiselseCardRequestComponent,
    SiselseListInterphonesComponent,
    SiselseInterphoneComponent,
    TransactionPrintComponent,
    SelectableItemTemplateComponent,
    selectableInstallationComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    RouterModule,
    TranslateModule.forChild(),
    SharedDirectivesModule,
    IonicSelectableModule,
    FormsModule,
    ReactiveFormsModule,
  ],
  exports: [
    AvatarComponent,
    MenuComponent,
    ExpandableComponent,
    RelayComponent,
    CalendarHeaderComponent,
    DetailViewComponent,
    DetailViewItemComponent,
    ImageUploadComponent,
    PopoverComponent,
    ColorPickerComponent,
    CountdownTimerComponent,
    FilterSelectableComponent,
    SaveDeleteButtonsComponent,
    CurrencyInputComponent,
    CurrencyInputBasicComponent,
    SiselseListPersonsComponent,
    SiselsePersonComponent,
    SiselseCardComponent,
    SiselseCardRequestComponent,
    SiselseListInterphonesComponent,
    SiselseInterphoneComponent,
    TransactionPrintComponent,
    SelectableItemTemplateComponent,
    selectableInstallationComponent,
  ],
})
export class SharedComponentsModule {}
